<template>
  <div class="related-links" v-if="slides">
    <img src="~@/assets/img/dzyndzle_short.svg" alt="" />
    <div class="counting" v-if="loading">
      Wczytuję kolekcję {{ slides.length }}/{{ collection.items_count }}
    </div>
    <div class="swiper-container swiper-container-1">
      <div class="swiper-wrapper">
        <div class="box-wrapper" style="width: 0"></div>
        <!-- Hack -->
        <div
          :class="slide_class"
          v-for="(slide, index) in slides"
          v-bind:key="index"
          ref="sliderElements"
        >
          
          <router-link
            :to="slide.path + '/' + slide.id"
            :title="slide.title"
            class="img-link"
            @click.native="getAnotherItem()"
          >
            <img :src="slide.file_urls.fullsize" alt="" class="swiper-lazy" />
            <svg class="box" preserveAspectRatio="none">
              <rect width="100%" height="100%" v-if="null" />
            </svg>
          </router-link>
        </div>
      </div>
    </div>
    <div class="related-controls">
      <a
        href="javascript:void(0)"
        class="related-control hidden inverse arrow-link test"
        title="Przewiń w lewo"
        rel="relatedControl"
        @click="slidePrev"
      >
        <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </a>
      <router-link class="link-to-collection" :to="'/kolekcja/' + collection.id"
        >ZOBACZ TEŻ INNE OBIEKTY Z KOLEKCJI</router-link
      >
      <a
        href="javascript:void(0)"
        class="related-control arrow-link"
        title="Przewiń w prawo"
        @click="slideNext"
      >
        <svg class="arrow-wrapper" viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import "swiper/swiper-bundle.css";

import Swiper from "swiper";
import axios from "axios";

import { eventBus } from "@/main.js";

export default {
  name: "ItemPlayerRelated",
  props: ["slides", "collection"],
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      widget: undefined,
      slide_class: "swiper-slide freeze",
      loading: true
    };
  },
  methods: {
    buildWidget() {
      
      this.widget = new Swiper(".swiper-container-1", {
        // options
        slidesPerView: "auto",
        observer: true,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        on: {
          transitionEnd: function (s) {
            0 === s.activeIndex
              ? $(".related-control.inverse").addClass("hidden")
              : $(".related-control.inverse").removeClass("hidden"),
              1 === s.progress
                ? $(".related-control:last-child").addClass("hidden")
                : $(".related-control:last-child").removeClass("hidden");
          },
        },
      });
    },
    slidePrev() {
      this.widget.slidePrev();
    },
    slideNext() {
      this.widget.slideNext();
    },
    imagesLoaded() {
      imagesLoaded(
        document.querySelector(".swiper-slide img"),
        function (instance) {
          var lastRight = 0;
          $(".swiper-slide img").each(function (i) {
            var bodyP = $("body>.container").offset().left,
              pLeft = $(this).css("padding-left");
            pLeft = +pLeft.substring(0, pLeft.length - 2);
            var left = $(this).offset().left + pLeft - bodyP,
              w = $(this).width(),
              h = $(this).height();
            if (0 != lastRight)
              var boxSize =
                left -
                (lastRight += 20 * Math.random() + 5) -
                30 * Math.random() -
                5;
            else boxSize = left - 15 * Math.random() - 5;
            $(".box-wrapper").append('<div class="box"></div>'),
              $(".box-wrapper>.box").last().css({
                top: 0,
                left: lastRight,
                width: boxSize,
                height: h,
              }),
              (lastRight = left + w);
          });
          var slide = $(".swiper-slide img").last(),
            h = (slide.offset().left, slide.width(), slide.height()),
            pRight = slide.css("padding-right");
          (pRight = +pRight.substring(0, pRight.length - 2)),
            (lastRight += 20 * Math.random() + 5);
          var boxSize = pRight + 15 * Math.random() + 10;
          $(".box-wrapper").append('<div class="box"></div>'),
            $(".box-wrapper>.box").last().css({
              top: 0,
              left: lastRight,
              width: boxSize,
              height: h,
            });
        }
      );
    },
    getAnotherItem() {
      eventBus.$emit("getAnotherItem");
    },
  },
  mounted: function () {
    this.buildWidget();
  },
  watch: {
    slides: function () {
      if (this.collection.items_count == this.slides.length) {
        this.loading = false;
        if (this.collection.items_count <= 1) {
          this.widget.centeredSlides = true;
        }
        this.imagesLoaded();
        this.slide_class = "swiper-slide";
      }
    },
  },
};
</script>

<style scoped>

.swiper-slide {
  width: 33%;
}

@media (max-width: 769px) {
 .swiper-slide {
  width: 100%;
  }   
}


.swiper-slide img {
  object-fit: cover;
}
.freeze {
  display: none;
}
.counting {
}

.link-to-collection {
  font-size: 1.8rem;
}

</style>



// WEBPACK FOOTER //
// src/components/ItemPlayer/ItemPlayerRelated.vue